<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <!-- <v-layout row wrap>
                    <v-flex xs2 class="mr-3">
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="fromDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="toDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </v-layout> -->

                <v-layout>
                    <v-flex xs8>
                        <!-- <v-data-table id="leads-status-report-table" :headers="tableHeaders" :items="report" :loading="loading" hide-actions class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left vertical-header">{{ props.item.db_name }}</td>
                                <td class="text-xs-left capitalize">£{{ new Intl.NumberFormat({ style: 'currency' }).format(props.item.sms_cost) }}</td>
                            </template>
                        </v-data-table> -->

                        <v-data-table id="leads-status-report-table" :headers="tableHeaders" :items="report" :loading="loading" hide-actions class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left vertical-header">{{ props.item.dtRange }}</td>
                                <td class="text-xs-left vertical-header">{{ props.item.db_name }}</td>
                                <td class="text-xs-center">{{ props.item.sendVolume }}</td>
                                <td class="text-xs-center">£{{ new Intl.NumberFormat({ style: 'currency' }).format(props.item.periodCostPreVAT) }}</td>
                                <td class="text-xs-center">{{ parseFloat(props.item.avgCharCount).toFixed(2) }}</td>
                                <td class="text-xs-center">{{ parseFloat(props.item.avgSmsCost).toFixed(3) }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        data() {
            return {
                fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                toDate: new Date().toISOString().substr(0, 10),
                total: 0,
                report: [],
                fromDateModal: false,
                toDateModal: false,
                loading: true
            }
        },
        beforeMount() {
            this.getReport();
        },
        computed: {
            tableHeaders() {
                // let tableHeaders = [{ text: 'Merchant', value: 'db_name', sortable: false },
                //                     { text: 'SMS Cost', sortable: false }];
                
                let tableHeaders = [{ text: 'Date', sortable: false },
                                    { text: 'Merchant', value: 'db_name', sortable: false },
                                    { text: 'Volume', sortable: false, align: 'center' },
                                    { text: 'Cost', sortable: false, align: 'center' },
                                    { text: 'Avg. Character Count', sortable: false, align: 'center' },
                                    { text: 'Avg. SMS Cost', sortable: false, align: 'center' }];
                return tableHeaders;
            }
        },
        methods: {
            getReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-sms-report-2',
                data: { fromDate: this.fromDate, toDate: this.toDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;

                    let date = '';
                    let length = this.report.length;

                    this.report.forEach(function(row, pos) {
                        if(pos < length) {
                            if(row.dtRange == date) {
                                row.dtRange = '';
                            }
                            else {
                                date = row.dtRange;
                            }
                        }
                    });
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            handleDateChange() {
                this.loading = true;
                if(this.toDate < this.fromDate) {
                    this.fromDate = this.toDate;
                }
                this.$refs.fromDateDialog.save(this.fromDate);
                this.$refs.toDateDialog.save(this.toDate);
                this.getReport();
            },
            twoDecimal(num) {
                return 'helo';
            }
        }
    }
</script>

<style>
    .vertical-header {
        font-weight: 600 !important;
        color: rgba(0,0,0,.54);
    }

    #leads-status-report-table {
        border-top: 1px solid rgba(0,0,0,.12);
    }
</style>